import gql from 'graphql-tag';

export const M_SET_TEXT_FLOW_TO_PERSON = gql`
  mutation($userId: Int!, $phoneNumberId: Int!) {
    update_textflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: $userId, group_id: null, keyword_routing: null }
    ) {
      affected_rows
    }
  }
`;

export const M_SET_TEXT_FLOW_TO_GROUP = gql`
  mutation($groupId: Int!, $phoneNumberId: Int!) {
    update_textflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: null, group_id: $groupId, keyword_routing: null }
    ) {
      affected_rows
    }
  }
`;

export const M_SET_TEXT_FLOW_TO_MENU = gql`
  mutation($textMenu: String!, $phoneNumberId: Int!) {
    update_textflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: null, group_id: null, keyword_routing: $textMenu }
    ) {
      affected_rows
    }
  }
`;


export const M_SET_TEXT_FLOW_TO_NOASSIGN = gql`
  mutation( $phoneNumberId: Int!) {
    update_textflows(
      where: { phone_number_id: { _eq: $phoneNumberId } }
      _set: { user_id: null, group_id: null, keyword_routing: null }
    ) {
      affected_rows
      returning {
        id
        user_id
        group_id
        keyword_routing
      }
    }
  }
`;
